import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  flightFareQuoteAsync,
  flightFareRuleAsync,
  flightSSRAsync,
  getFareQuote,
  getFareRules,
  getLoading,
  ResetFlightSearch,
  ResetLoader,
  resetSession,
} from "../../../../features/bookings/flightSlice";
import { getLogin } from "../../../../features/userSlice";
import Loader from "../../../../helpers/Loader";
import { errorToast } from "../../../../helpers/toaster";
import FlightGuestForm from "./FlightGuestForm";
import PriceData from "./PriceData";
import TicketDetails from "./TicketDetails";

const FLightPayment = () => {
  const dispatch = useDispatch();
  const loading = useSelector(getLoading);
  // const userData = useSelector(getLogin);
  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};

  // const userData = useSelector((state) => state.user.userData, shallowEqual);
  const navigate = useNavigate();
  // const login = useSelector(getLogin);

  // React.useEffect(() => {

  //   if (login?.length === 0) {
  //     // navigate("/flight");
  //   }
  // }, [login]);

  useEffect(() => {
    dispatch(ResetFlightSearch());
  }, []);

  const flightTrackingToken =
    JSON.parse(sessionStorage.getItem("flightTrackingToken")) || {};
  const flightForm = JSON.parse(sessionStorage.getItem("flightForm")) || {};

  const [rules, setRules] = React.useState("");

  const flightResultId = JSON.parse(sessionStorage.getItem("flightResultId"));

  const fareRules = useSelector(getFareRules);

  const sessionExpired = useSelector(
    (state) => state.flight.sessionExpired,
    shallowEqual
  );

  useEffect(() => {
    setRules(fareRules?.FareRules?.[0]?.[0]?.FareRuleDetail);
  }, [fareRules]);

  useEffect(() => {
    if (Object.keys(flightTrackingToken).length > 0) {
      dispatch(
        flightFareRuleAsync({
          ResultId: flightResultId,
          TokenId: flightTrackingToken.flightTokenId,
          TrackingId: flightTrackingToken.flightTrackingId,
          Authorization: userData.Authorization,
        })
      );
      dispatch(
        flightFareQuoteAsync({
          ResultId: flightResultId,
          TrackingId: flightTrackingToken.flightTrackingId,
          Authorization: userData.Authorization,
        })
      );
      dispatch(
        flightSSRAsync({
          ResultId: flightResultId,
          TokenId: flightTrackingToken.flightTokenId,
          TrackingId: flightTrackingToken.flightTrackingId,
          Authorization: userData.Authorization,
        })
      );
    } else {
      navigate("/flight");
    }
  }, []);

  useEffect(() => {
    if (sessionExpired) {
      navigate(-1);
      dispatch(resetSession());
      errorToast("Session Expired!");
    }
  }, [sessionExpired]);

  const fareQuote = useSelector(getFareQuote);

  const { Result } = fareQuote || {};

  const { Fare } = Result?.[0] || {};

  // if (loading) {
  //   return <Loader />;
  // }

  return (
    <section className="review-booking ticket-details-main-section">
      <div className="container">
        <div className="row">
          <div>
            <h3 className="title">Ticket Details</h3>
          </div>

          <div className="col-lg-8">
            {loading ? (
              <div class="loader-bg-border">
                <div class="row justify-content-between align-items-center w-100">
                  <div class="col-lg-3">
                    <span class="loader-bg p-3 mb-2 d-block w-25 rounded"></span>
                    <span class="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                    <span class="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                    <span class="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                    <span class="loader-bg pt-4 mb-2 d-block w-75 me-2 rounded"></span>
                  </div>
                  <div class="col-lg-3">
                    <span class="loader-bg pt-4 mb-2 d-block w-75 me-2 rounded"></span>
                    <span class="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                    <span class="loader-bg pt-4 mb-2 d-block w-100 me-2 rounded"></span>
                  </div>
                  <div class="col-lg-3 text-center">
                    <span class="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                  </div>
                  <div class="col-lg-3">
                    <span class="loader-bg p-3 mb-2 d-block w-25 rounded"></span>
                    <span class="loader-bg pt-4 mb-2 d-block w-100 me-2 rounded"></span>
                    <span class="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <TicketDetails
                  Result={Result}
                  returnTrip={
                    flightForm?.state?.ReturnDate !== undefined &&
                    flightForm?.state?.ReturnDate !== null
                  }
                />

                <div className="review-booking-wrapper flight-detail-lists-main p-0 review-booking-rating booking-list d-block room-inclusions">
                  <div className="room-inclusions-title">
                    <div className="row l-pink-bg">
                      <div className="col-lg-12">
                        <div className="title-1">
                          <h5 className="b-b-16 mb-0">Important Information</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="check-in-out-list">
                        {rules !== undefined && rules !== "" && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: fareRules?.FareRules[0][0].FareRuleDetail,
                            }}
                          ></div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="mt-5">
              <h3 className="title">Guest Details</h3>
            </div>

            <FlightGuestForm
              fareQuote={fareQuote}
              fareRulesDetail={fareRules?.FareRules?.[0]?.[0]?.FareRuleDetail}
            />
          </div>

          <div className="col-lg-4">
            {loading ? (
              <div class="loader-bg structure-box2"></div>
            ) : (
              <PriceData Fare={Fare} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FLightPayment;
